import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Subject } from 'rxjs';
import { EmpresaService } from '../../../services/empresa.service';
import { FacturacionService } from '../../../services/facturacion.service';
import { GrupoService } from '../../../services/grupo.service';
import { SolicitudService } from '../../../services/solicitud.service';
import { DataTableDirective } from 'angular-datatables';
import { Solicitud } from '../../../models/solicitud';
import { Empresa } from '../../../models/empresa';

@Component({
	selector: 'app-empresas',
	templateUrl: './empresas.component.html',
	styleUrls: ['./empresas.component.css'],
	providers: [EmpresaService, GrupoService, FacturacionService, SolicitudService]
})
export class EmpresasComponent implements OnInit {
	public identity;
	public token;
	public status;
	public status_update;
	public message_success;
	public message_error;
	public message_update_success;
	public message_update_error;
	public empresa: Empresa;
	public empresas: any;
	public solicitud: Solicitud;
	public form;
	public dtOptions: DataTables.Settings = {};
	public dtTrigger: Subject<any> = new Subject();

	public empresa_id;
	public rfc;
	public denominacion;
	public nombre_establecimiento;
	public habitaciones;
	public calle;
	public no_interior;
	public no_exterior;
	public cp;
	public colonia;

	@ViewChild(DataTableDirective)
	public dtElement: DataTableDirective;

	constructor(
		private _route: ActivatedRoute,
		private _router: Router,
		private _grupoService: GrupoService,
		private _empresaService: EmpresaService,
	) {
		this.identity = this._grupoService.getIdentity();
		this.token = this._grupoService.getToken();
		this.solicitud = new Solicitud(1, 0, '', '', '', '', '', '', '', '', '');
		this.empresa = new Empresa(1, '', '', '', 1, '', 1, 1, 1, '', '');
	}

	ngOnInit() {
		this.dtOptions = {
			pagingType: 'full_numbers',
			pageLength: 10
		}
		this.getEmpresas();
	}

	getEmpresas() {
		this._empresaService.getEmpresasByGrupo(this.token).subscribe(
			response => {
				// Obtener el token 
				if (response.status == 'success') {
					this.empresas = response.empresas;
					this.dtTrigger.next();
				} else {
					this.message_error = response.message;
				}
			},
			error => {
				if (error['status'] == 401) {
					this._router.navigate(['logout/1']);
				} else {
					this.empresas = null;
					this.message_error = error;
				}
			}
		);
	}

	getImage(image) {
		let img: any = image.target;
		if (img.files.length > 0) {

			this.form = new FormData();
			// indicamos que form contendra el valor de files en la posición 0
			this.form.append('image', img.files[0]);
		}
	}

	create(form) {
		if (this.form == null) {
			$(".message").show();
			this.status = 'error';
			this.message_error = 'Favor de adjuntar la imagen';
			setTimeout(function () {
				$(".message").fadeTo(500, 1).slideUp(500, function () {
					$(".message").hide();
				});
			}, 3000);
		} else {
			if (this.empresa['nombre_establecimiento'].length == 0 || this.empresa['licencia_funcionamiento'].length == 0) {
				$(".message").show();
				this.status = 'error';
				this.message_error = 'El nombre y la licencia del establecimiento son de caracter obligatorio';
				setTimeout(function () {
					$(".message").fadeTo(500, 1).slideUp(500, function () {
						$(".message").hide();
					});
				}, 3000);
			} else {
				$(".loading").show();
				this._empresaService.attachEmpresa(this.token, this.form, this.empresa['nombre_establecimiento'], this.empresa['licencia_funcionamiento']).subscribe(
					response => {
						// Obtener el token 
						if (response.status == 'success') {
							$(".loading").hide();

							$(".message").show();
							form.reset();
							$("#img").val('')
							this.status = response.status;
							this.message_success = response.message;
							setTimeout(function () {
								$(".message").fadeTo(500, 1).slideUp(500, function () {
									$(".message").hide();
								});
							}, 3000);
						}
					},
					error => {
						$(".loading").hide();

						if (error['status'] == 401) {
							this._router.navigate(['logout/1']);
						} else {
							$(".message").show();
							this.status = 'error';
							this.message_error = error['error']['message'];
							setTimeout(function () {
								$(".message").fadeTo(500, 1).slideUp(500, function () {
									$(".message").hide();
								});
							}, 3000);
						}
					}
				);
			}
		}
	}

	update(empresa_id) {
		this.empresa_id = empresa_id;
		this.rfc = $("#rfcAct" + this.empresa_id).val();
		//this.denominacion = $("#denAct" + this.empresa_id).val();
		//this.nombre_establecimiento = $("#nesAct" + this.empresa_id).val();
		this.habitaciones = $("#habAct" + this.empresa_id).val();
		this.calle = $("#calleAct" + this.empresa_id).val();
		this.no_interior = $("#noinAct" + this.empresa_id).val();
		this.no_exterior = $("#noexAct" + this.empresa_id).val();
		this.cp = $("#cpAct" + this.empresa_id).val();
		//this.colonia = $("#colAct" + this.empresa_id).val();

		this.empresa = new Empresa(
			this.empresa_id, this.rfc, this.denominacion, this.nombre_establecimiento, this.habitaciones,
			this.calle, this.no_interior, this.no_exterior, this.cp, this.colonia, '');

		this.empresa = new Empresa(
			this.empresa_id, this.rfc, this.denominacion, this.nombre_establecimiento, this.habitaciones,
			this.calle, this.no_interior, this.no_exterior, this.cp, this.colonia, '');

		this._empresaService.updateEmpresa(this.token, this.empresa_id, this.empresa).subscribe(
			response => {
				if (response.status == 'success') {

					$(".empresa_update").show();

					this.status_update = 'success';
					this.message_update_success = response.message;

					setTimeout(function () {
						$(".empresa_update").fadeTo(500, 1).slideUp(500, function () {
							$(".empresa_update").hide();
						});
					}, 3000)
				}
			},
			error => {
				if (error['status'] == 401) {
					this._router.navigate(['logout/1']);
				} else {
					$(".empresa_update").show();
					this.status_update = 'error';
					this.message_update_error = error['error']['message'];

					setTimeout(function () {
						$(".empresa_update").fadeTo(500, 1).slideUp(500, function () {
							$(".empresa_update").hide();
						});
					}, 3000)
				}
			}
		);
	}

}
